<script>
import { zendeskActions, zendeskValidateActions } from '@state/helpers'
import { mapState } from 'vuex'
import zendesk from '@/mixins/zendesk-utils.js'
import screensValidations from '@/mixins/screens-validations.js'
import PanelProductItem from '@components/panel-product-item'
import PanelProductItemMarket from '@components/panel-product-item-market'
import ProductItem from '@components/product-item'
import SubHeader from '@components/sub-header'
import NapkinsItem from '@components/napkins-item'

export default {
  name: 'ProductsWrapper',
  components: {
    PanelProductItem,
    PanelProductItemMarket,
    ProductItem,
    SubHeader,
    NapkinsItem,
  },
  mixins: [zendesk(), screensValidations()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedProducts: [],
      restaurantProducts: [],
      productIdKey: 'product_id',
      baseIndex: 0,
    }
  },
  computed: {
    ...mapState('widgets', {
      orderData: state => state.data.SharedData.orderData,
      articleId: state => state.common.params.articleId
    }),
    isIncompleteOrder() {
      return this.articleId === '5d5f17f51842a80013b6ac3f'
    },
    changeTitle(){
      return this.isIncompleteOrder
        ? this.$t('COMPONENTS.PRODUCTS_WRAPPER.TITLE')
        : this.componentData.title
    },
    isRestaurantStoreType() {
      const storeType = this.orderData.init_store_type || this.newStoreType
      return storeType === 'restaurant'
    },
    computedWhims() {
      return this.componentData.whims.map(w => {
        w.image = 'https://lupe.rappi.com/assets/images/default-product.png'
        w.units = 1
        w.product_id = this.$t('WIDGETS.PRODUCTS_WRAPPER.WHIMS')
        return w
      })
    },
    newStoreType() {
      return this.orderData.calculated_information.init_store_type === 'whim'
        ? this.orderData.calculated_information.store_type
        : this.orderData.calculated_information.init_store_type
    },
    isValidOverload() {
      return (
        this.selectedProducts.length < this.componentData.products.length &&
        this.isIncompleteScreenKustomer
      )
    },
    isInvalidOverload() {
      const baseProducts = this.isRestaurantStoreType
        ? this.restaurantProducts
        : this.componentData.products
      return (
        this.selectedProducts.length >= baseProducts.length &&
        this.isIncompleteScreenKustomer
      )
    },
    isRegularProductSelection() {
      return this.selectedProducts.length > 0
    },
  },
  watch: {
    selectedProducts() {
      const { name } = this.$options

      this.commitCustomField({
        value: JSON.stringify(this.selectedProducts),
        key: 'products',
      })

      if (this.selectedProducts.length > 0) {
        this.commitValidatedField({
          type: 'function',
          key: 'productsValidation',
          name,
          value: this.selectedProducts,
          message: this.$t('COMMON.REQUIRED_PRODUCT.BASE'),
        })
      } else {
        this.removeValidatedField({ key: 'productsValidation' })
      }

      // if (this.isInvalidOverload) {
      //   this.commitRequiredFields({
      //     type: 'function',
      //     key: 'productsIncompleteValidation',
      //     name,
      //     message: this.$t('COMMON.REQUIRED_PRODUCT.OVERLOAD'),
      //   })
      // } else if (this.isValidOverload) {
      //   this.removeValidatedField({ key: 'productsIncompleteValidation' })
      // }
    },
  },
  created() {
    if (this.isRestaurantStoreType) {
      this.productIdKey = 'new_product_id'
      for (let product of this.componentData.products) {
        this.processRestaurantProduct(product)
      }
    }
    this.validateRequired()
  },
  methods: {
    ...zendeskActions,
    ...zendeskValidateActions,
    processRestaurantProduct(product) {
      if (product.units || product.pivot.units > 1) {
        this.obtainMultipleProductsFromUnits(product)
      } else {
        this.restaurantProducts.push(
          this.cloneRestaurantProduct(product, this.baseIndex)
        )
      }
      this.baseIndex++
    },
    obtainMultipleProductsFromUnits(product) {
      const units = product.units || product.pivot.units
      for (var i = 0; i < units; ++i) {
        this.restaurantProducts.push(
          this.cloneRestaurantProduct(product, `${this.baseIndex}-${i}`)
        )
      }
    },
    cloneRestaurantProduct(product, index = 0) {
      const productId = product.id || product.product_id
      return Object.assign({}, product, {
        quantity: 1,
        complainedUnits: 1,
        new_product_id: `${productId}-${index}`,
      })
    },
    findProductIndex(product) {
      if (this.isRestaurantStoreType)
        return this.selectedProducts.findIndex(
          p => p[this.productIdKey] === product[this.productIdKey]
        )
      else return this.selectedProducts.findIndex(p => p.id === product.id)
    },
    onProductsUpdate(product) {
      product = JSON.parse(JSON.stringify(product))
      const index = this.findProductIndex(product)
      let productsAux = this.selectedProducts
      if (product.include) {
        if (index > -1) {
          productsAux = Object.assign([], productsAux, { [index]: product });
        } else {
          productsAux = [...productsAux, product]
        }
      } else {
        productsAux = [
          ...this.selectedProducts.slice(0, index),
          ...this.selectedProducts.slice(index + 1),
        ]
      }

      this.selectedProducts = JSON.parse(JSON.stringify(productsAux))
    },
    validateRequired() {
      const { name } = this.$options
      this.commitRequiredFields({
        type: 'function',
        key: 'productsValidation',
        name,
        message: this.$t('COMMON.REQUIRED_PRODUCT.BASE'),
      })
    },
  },
}
</script>

<template>
  <div
    :class="$style.container"
    :id="`${this.$options.name}-container`">
    <SubHeader :text="changeTitle" />

    <template v-if="isRestaurantStoreType">
      <PanelProductItem
        v-for="(product, i) in restaurantProducts"
        :key="i"
        :product="product"
        :component-data="componentData"
        @productUpdate="onProductsUpdate"
      />
      <NapkinsItem
        :item="componentData.napkins"
        @productUpdate="onProductsUpdate"
      />
    </template>

    <template v-else>
      <v-list
        :class="$style.vList"
        subheader>
        <PanelProductItemMarket
          v-for="(product, i) in componentData.products"
          :key="i"
          :product="product"
          @productUpdate="onProductsUpdate"
        />
      </v-list>
    </template>

    <template v-if="computedWhims.length > 0">
      <SubHeader :text="$t('WIDGETS.PRODUCTS_WRAPPER.WHIMS')" />
      <v-list
        :class="$style.vList"
        subheader>
        <ProductItem
          v-for="(whim, i) in computedWhims"
          :key="i"
          :product="whim"
          @productUpdate="onProductsUpdate"
        />
      </v-list>
    </template>
  </div>
</template>
<style lang="scss" module scoped>
@import '@design';

.container {
  padding: $size-spacing-medium 0 0 0;
  background-color: $background-container;
  margin: 0;
}

.vList {
  padding: 0;
  background: $background-container;
}
</style>
